import { SYSFormField } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

export type NewServiceStep1FormFieldKeys =
  | "requesterEmail"
  | "requesterPhone"
  | "group"
  | "problemType"
  | "planningStartDate"
  | "planningSlots"
  | "promoCode"
  | "promoCode2"
  | "promoCode3"

export let NewServiceFormStep1FieldsDef: {
  [key in NewServiceStep1FormFieldKeys]: SYSFormField
} = {
  requesterEmail: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterEmail",
      autocomplete: "email",
      inputMode: "email",
    },
  },
  requesterPhone: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterPhone",
      autocomplete: "tel",
      inputMode: "tel",
    },
  },

  group: {
    list: {
      valueField: "Group",
      displayField: "Group",
      displayValueField: false,
    },
    schema: { nullable: false },
    value: "",
    type: "text",
    ui: {
      labelTranslationKey: "NewServiceProblemGroup",
      visible: "fadeIn",
    },
  },

  problemType: {
    list: {
      valueField: "ProblemType",
      displayField: "ProblemDesc",
      mode: "Select",
      acceptOnlyListValues: true,

      displayValueField: false,
    },
    schema: { nullable: false },
    value: "",
    type: "int",
    ui: {
      labelTranslationKey: "NewServiceProblemType",
      visible: "fadeIn",
    },
  },

  planningStartDate: {
    type: "date",
    value: "",
    schema: { isCalculatedColumn: true },
    ui: {
      labelTranslationKey: "NewServicePlanningStartDate",
      useBrowserDatePicker: true,
      readonly: true,
    },
  },
  planningSlots: {
    list: {
      valueField: "DateKey",
      displayField: "DateDesc",
      mode: "Option",
    },
    schema: {
      nullable: false,
      nullValidatorOptions: { validation: { displayType: "OnlyOutline" } },
    },
    value: undefined,
    type: "text",
    ui: {
      labelTranslationKey: "NewServicePlanningSlots",
      visible: "false",
    },
  },
  promoCode: {
    value: "A",
    ui: {
      readonly: true,
      noLabel: true,
      align: "center",
    },
  },
  promoCode2: {
    value: "",
    type: "int",
    ui: {
      noLabel: true,
      format: "4digitsInteger",
      align: "center",
    },
  },
  promoCode3: {
    value: "",
    type: "int",
    ui: {
      noLabel: true,
      format: "4digitsInteger",
      align: "center",
    },
  },
}
